import { DateNavigator } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  dateNavigationOpenButton: {},
}));

export const DateNavigationOpenButtonComponent = (
  props: DateNavigator.OpenButtonProps
) => {
  const { classes } = useStyles();
  return (
    <DateNavigator.OpenButton
      className={classes.dateNavigationOpenButton}
      {...props}
      data-testid="DateNavigationOpenButtonComponent"
    ></DateNavigator.OpenButton>
  );
};
